import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
    }
    body {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        font-weight: 300;
        font-size: 16px;
        font-family: 'Open Sans';
        background-color: #EDE9E9;
        color: #000000;
    }
`

export default GlobalStyle